import React, { useState } from 'react'
import PropTypes from 'prop-types'

import AdSuggestions from './AdSuggestions'
import { SecondaryButton } from 'components/Shared/Button'
import PortalModal from 'components/Shared/PortalModal'
import { CancelIcon, ArrowDownThreeIcon } from 'images'
import { useTranslation } from 'react-i18next'

const AdsSummaryItem = ({ title, value, adSuggestions }) => {
    const { t } = useTranslation()
    const [isModalOpen, setModalOpen] = useState(false)

    return <div className='card card-no-padding-mobile rounded flex-row'>
        <div className='d-flex w-100'>
            <div>
                <div className="summary_item_icon">
                    <i className="icon-campaign" />
                </div>
            </div>
            <div className='d-flex justify-content-between flex-wrap gap-3 w-100'>
                <p className="summary_item_content">
                    <strong>
                        {value}
                    </strong>
                    <span>
                        {title}
                    </span>
                </p>
                <div className='summary_item_button'>
                    <SecondaryButton text={t('Recommendations.summary.previewAds')} color='navy' size='small' onClick={() => setModalOpen(true)}/>
                </div>
            </div>
        </div>
        
        <PortalModal isOpen={isModalOpen} className="full-height" onClickOutside={() => setModalOpen(false)}>
            <div className='summary_modal'>
                <div className='summary_modal_disclaimer'>
                    <div>
                        <h4>{t('Recommendations.summary.previewDisclaimer.title')}</h4>
                        <div>
                            {t('Recommendations.summary.previewDisclaimer.description')}
                        </div>
                    </div>
                    <div>
                        <button type="button" onClick={() => setModalOpen(false)} className="summary_close-btn_wrapper">
                            <CancelIcon width={14} className="summary_close-btn_icon"/>
                        </button>
                    </div>
                </div>
                <div className='summary_modal_down-arrow'>
                    <ArrowDownThreeIcon width={20} onClick={() => { window.location = '#ad-suggestions' }} className="c-hover"></ArrowDownThreeIcon>
                </div>
                <div className='summary_modal_content' id='ad-suggestions'>
                    <AdSuggestions adSuggestionsRegular={adSuggestions.regular} adSuggestionsReels={adSuggestions.reels} />
                </div>
            </div>
        </PortalModal>
    </div>
}

AdsSummaryItem.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    adSuggestions: PropTypes.object,
}

export default AdsSummaryItem